import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const BASE = "/locationbundletemplates";
const ApiName = "LocationBundleTemplates";
const buildUrl = (endpoint) => BASE + endpoint;

const locationBundleTemplateSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getLocationBundleTemplates: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (result, error, arg) => [{ type: ApiName}],
            onQueryStarted: muiDataGridStarted.bind(null, 'getLocationBundleTemplates', ApiName)
        }),
        getLocationBundleTemplate: builder.query({
            query: (id) => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
            }),
            providesTags: (result, error, id) => [{ type: ApiName, id }],
        }),
        getLocationBundleTemplatesSelect: builder.query({
            query: () => ({
                url: buildUrl(`/`),
                method: 'GET',
            }),
            providesTags: (result, error, arg) => [{ type: ApiName}],
        }),
        updateLocationBundleTemplate: builder.mutation({
            query: bundleInfo => ({
                url: buildUrl(`/${bundleInfo.id}`),
                method: 'PUT',
                body: bundleInfo,
            }),
            invalidatesTags: (result, error, { id }) => [{ type: ApiName, id }, { type: ApiName }],
        }),
        addLocationBundleTemplate: builder.mutation({
            query: bundleInfo => ({
                url: buildUrl(`/add`),
                method: 'POST',
                body: bundleInfo,
            }),
            invalidatesTags: (result, error, { id }) => [{ type: ApiName }],
        }),
        deleteLocationBundleTemplate: builder.mutation({
            query: args => ({
                url: buildUrl(`/${args.id}`),
                method: 'DELETE'
            }),
            invalidatesTags: (result, error, arg) => [{type: ApiName}],
        }),
    })
});

export const { 
    useGetLocationBundleTemplateQuery,
    useGetLocationBundleTemplatesQuery,
    useGetLocationBundleTemplatesSelectQuery,
    useUpdateLocationBundleTemplateMutation,
    useAddLocationBundleTemplateMutation,
    useDeleteLocationBundleTemplateMutation
} = locationBundleTemplateSlice;
